import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "../../components/confirmation-dialog/confirmation-dialog.component";

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  constructor(private dialog: MatDialog) {}

  confirm(
    message: string,
    title = 'Confirmation',
    onConfirm: () => void,
    onCancel?: () => void,
    confirmText= "CONFIRM",
    confirmColor="warn",
    confirmIcon="check"
  ): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      maxWidth: '90vw',
      data: { title, message, confirmText, confirmColor, confirmIcon},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        onConfirm();
      } else if (onCancel) {
        onCancel();
      }
    });
  }
}
